import React, { useContext, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import PropTypes from 'prop-types'
import FirebaseContext from '../../contexts/FirebaseContext'
import AuthContext from '../../contexts/AuthContext'
import LoginPage from '../../Pages/Login'
import LoadingSystem from '../../common/LoadingSystem'
import {
  getLoadingFirstName,
  getLoadingGreeting
} from '../../common/LoadingSystem/getLoadingGreeting'

const propTypes = {
  children: PropTypes.node
}

const ForceLogin = (props) => {
  const firebase = useContext(FirebaseContext)
  const logged = useContext(AuthContext)
  const [cookie, , removeCookie] = useCookies(['znk-signup'])
  const [loading, setLoading] = useState(true)
  const loadingGreeting = getLoadingGreeting({
    timezone: global.localStorage.getItem('timezone') || undefined,
    firstName: getLoadingFirstName()
  })
  useEffect(() => {
    setLoading(true)
    async function getUserAsync(signinToken) {
      if (!firebase) {
        return
      }
      if (!logged) {
        if (!signinToken) {
          setLoading(false)
          return
        }
        try {
          await firebase.auth().signInWithCustomToken(signinToken)
        } catch (e) {
          if (e.code === 'auth/invalid-custom-token') {
            removeCookie('znk-signup')
          }
        }
      }
      setLoading(false)
    }
    getUserAsync(cookie['znk-signup'])
  }, [cookie, firebase, logged, removeCookie])
  return loading ? (
    <LoadingSystem greetingText={loadingGreeting} />
  ) : logged ? (
    props.children
  ) : (
    <LoginPage />
  )
}

ForceLogin.propTypes = propTypes
export default ForceLogin
